import React, { useState, useEffect } from 'react';
import CategoryTree from './CategoryTree';
import { useGlobalProvider } from '../contexts/GlobalProvider';

const CategoryTreeModal = ({ isOpen, onClose, onCategorySet }) => {
    const { selectedCategoryId, setSelectedCategoryId } = useGlobalProvider();
    const [tempSelectedCategoryId, setTempSelectedCategoryId] = useState(selectedCategoryId);
    const [shouldTriggerReload, setShouldTriggerReload] = useState(false);

    // Update temp selection when modal opens
    useEffect(() => {
        if (isOpen) {
            setTempSelectedCategoryId(selectedCategoryId);
        }
    }, [isOpen, selectedCategoryId]);

    // Trigger reload after category actually changes
    useEffect(() => {
        if (shouldTriggerReload && onCategorySet) {
            console.log('Category state updated, now calling onCategorySet to reload assets');
            onCategorySet();
            setShouldTriggerReload(false);
        }
    }, [selectedCategoryId, shouldTriggerReload, onCategorySet]);

    const handleSetCategory = () => {
        console.log('Setting category - current selectedCategoryId:', selectedCategoryId);
        console.log('Setting category - tempSelectedCategoryId:', tempSelectedCategoryId);
        setSelectedCategoryId(tempSelectedCategoryId);
        setShouldTriggerReload(true); // Flag to trigger reload after state updates
        onClose();
    };

    const handleCancel = () => {
        setTempSelectedCategoryId(selectedCategoryId); // Reset to original selection
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Asset Categories</h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleCancel}
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="alert alert-info" role="alert">
                            <i className="bi bi-info-circle me-2"></i>
                            If no category is selected, the "All Assets" button will retrieve all categories. Depending on the number, it may take a while.
                        </div>
                        <div className="border rounded p-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <CategoryTree tempSelectedCategoryId={tempSelectedCategoryId} setTempSelectedCategoryId={setTempSelectedCategoryId} />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSetCategory}
                        >
                            Set Category
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CategoryTreeModal;